import * as Tt from "@radix-ui/react-tooltip";
import { useState } from "react";
import Modal from "./Modal";

export default function Tooltip({
  children,
  headline = "",
  content,
  mode = "tooltip",
}) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  return mode === "tooltip" ? (
    <Tt.Provider>
      <Tt.Root
        open={tooltipOpen}
        onOpenChange={setTooltipOpen}
        delayDuration={0}
      >
        <Tt.Trigger onClick={() => setTooltipOpen((p) => !p)} asChild>
          {children}
        </Tt.Trigger>
        <Tt.Portal>
          <Tt.Content
            className=" select-none rounded-[4px] bg-gray-200 px-[15px] py-[10px] text-[15px] leading-none will-change-[transform,opacity]"
            sideOffset={5}
          >
            <div className="max-w-[80vw]  ">{content}</div>
            <Tt.Arrow className="fill-gray-200" />
          </Tt.Content>
        </Tt.Portal>
      </Tt.Root>
    </Tt.Provider>
  ) : (
    <>
      <div onClick={() => setTooltipOpen(true)}>{children}</div>

      <Modal
        isOpen={tooltipOpen}
        setIsOpen={setTooltipOpen}
        headline={headline}
      >
        <div dangerouslySetInnerHTML={{ __html: content }}></div>
      </Modal>
    </>
  );
}
